<template>
<div class="container-fluid" id="EmailMembers">
	
	<tip-tap-editor editor_type="default" />

</div>
</template>


<script>
import TipTapEditor from '../components/TipTapEditor.vue';

export default {
	name: "EmailMembers",
	components:{
		TipTapEditor,
	},
	props: {
	},
	data() {
		return {
		}
	},
	mounted() {
	},
	methods: {
	}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
